import { render, staticRenderFns } from "./SingleOccasion.vue?vue&type=template&id=cded9830&"
import script from "./SingleOccasion.vue?vue&type=script&lang=ts&"
export * from "./SingleOccasion.vue?vue&type=script&lang=ts&"
import style0 from "./SingleOccasion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports